import { z } from 'zod';

import { imageDisclaimerSchema } from './imageDisclaimerSchema';
import { poweredByDisclaimerSchema } from './poweredByDisclaimerSchema';

export const IDisclaimerSchema = z.union([poweredByDisclaimerSchema, imageDisclaimerSchema]);

export type IDisclaimer = z.infer<typeof IDisclaimerSchema>;
